export const CREATE_UNIT = 'CREATE_UNIT';
export const DELETE_UNIT = 'DELETE_UNIT';
export const SAVE_UNIT = 'SAVE_UNIT';
export const UPDATE_UNIT = 'UPDATE_UNIT';
export const UPDATE_UNITS_LIST = 'UPDATE_UNITS_LIST';
export const UNIT_OPTIONS = 'UNIT_OPTIONS';
